import * as React from 'react';
import { getFormattedCurrencyWithIdealDenomination } from 'utils/number';

import { Wrapper, Row, Color, Title, Range, Value } from './styles';

export const ChartMenu = props => {
	const { data, currencySymbol } = props;
	const sum = data.reduce((acc, item) => acc + item.value, 0);
	const formatPrice = value => {
		let formattedPrice = getFormattedCurrencyWithIdealDenomination({
			value: value,
			isUnitSign: true,
		}).toUpperCase();

		formattedPrice = formattedPrice
			? `${currencySymbol}${formattedPrice}`
			: formattedPrice;

		return formattedPrice;
	};
	return (
		<Wrapper>
			{data.map(item => (
				<Row key={item.name}>
					<Color color={item.color} />
					<Title>{item.name}</Title>
					<Range>({Math.round((item.value / sum) * 1000) / 10}%)</Range>
					<Value>{formatPrice(item.value)}</Value>
				</Row>
			))}
		</Wrapper>
	);
};
